import { Environments } from '../environment/environments';
import { consoleLogger } from '../logging/consoleLogger';
import { UtiqEvents } from './events';

export const getEventFieldsTemplate = (environment, eventName) => {
  try {
    switch (environment) {
      case Environments.Utiq:
        return UtiqEvents[eventName].fieldsTemplate;
      default:
        consoleLogger.logError(
          `Unrecognized environment ${environment} for event ${eventName}`,
        );
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    consoleLogger.logError(
      `Event ${eventName} is not defined. Make sure that the event name is correct or create a new event with this name`,
    );
    return null;
  }
};
